import { render, staticRenderFns } from "./EmpleadosInactivos.vue?vue&type=template&id=0e026506&scoped=true"
import script from "./EmpleadosInactivos.vue?vue&type=script&lang=js"
export * from "./EmpleadosInactivos.vue?vue&type=script&lang=js"
import style0 from "./EmpleadosInactivos.vue?vue&type=style&index=0&id=0e026506&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e026506",
  null
  
)

export default component.exports